import {Button, Col, Row} from "reactstrap";
import { Edit2, X, ChevronLeft, ChevronRight } from "react-feather";
import {ADMIN, SUPER_ADMIN} from "./upravljanje/Organizacije/Organisations";
import {useHistory} from "react-router-dom";
import {getUserData} from "../utility/Utils";
import {isAdmin, isSuperAdmin} from "../utility/UserUtility";


const CustomHeader = (props) => {
    let history = useHistory();
    let role = getUserData().userData.role;
    let onClick = props.onClick;
    if (!onClick) {
        onClick = () => {
            history.push(props.newUrl);
        }
    }

    console.log("Custom header props", props)
    let roleHasAccess = false;
    if (props.roles) {
        props.roles.map((myRole => {
            role.map((oneRole) => {
                if (myRole === oneRole) {
                    roleHasAccess = true
                }
            })

        }))
    }
    return (
        <div className='invoice-list-table-header w-100 mr-1 ml-50 mt-2 mb-75'>
            <Row>
                <Col xl='6' className='d-flex align-items-center p-0'>
                    <h3>{typeof props.name === "function" ? props.name() : props.name}</h3>
                </Col>
                {(isSuperAdmin() || (!props.superAdminOnly && (isAdmin() || roleHasAccess))) &&
                <Col
                    xl='6'
                    className='d-flex align-items-sm-center justify-content-lg-end justify-content-start flex-lg-nowrap flex-wrap flex-sm-row flex-column pr-lg-1 p-0 mt-lg-0 mt-1'
                >
                    {!props.hideNewButton &&
                    <Button.Ripple color='primary' onClick={onClick}>
                        {props.new}
                    </Button.Ripple>
                    }
                    {props.new2 &&
                    <Button.Ripple style={{marginLeft: "22px"}} color='primary' onClick={props.onClick2}>
                        {props.new2}
                    </Button.Ripple>
                    }
                    {
                      props.edit &&
                        <Edit2 className="cursor-pointer" onClick={props.onClickEdit}/>
                    }
                    {
                      props.isEdit &&
                      <X className="cursor-pointer" onClick={props.onClickX}/>
                    }
                </Col>
                }
            </Row>
            {props.children &&
            <Row>
                {props.children}
            </Row>
            }
            {
                props.resize &&
                <div 
                style={{fontSize:"small"}} 
                className='d-flex align-items-center p-0'>
                    <ChevronLeft
                     onClick={() => props.setTableRowWidth(props.tableRowWidth > 1 ? (props.tableRowWidth - 1) : props.tableRowWidth)} 
                     style={{width: "16px", cursor: "pointer"}}/>
                        Širina naziva
                    <ChevronRight 
                     onClick={() => props.setTableRowWidth(props.tableRowWidth < 6 ? (props.tableRowWidth - (-1)) : props.tableRowWidth)}
                     style={{width: "16px", cursor: "pointer"}}/>
                </div>

            }

        </div>
    )
}
export default CustomHeader;